import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';

import { AuthService } from '../core/upgraded-providers';

@Injectable()
export class UserResolver implements Resolve<any> {

    constructor(
        private _authService: AuthService
    ) {
    }

    resolve(): Promise<any> {
        return new Promise(async (resolve) => {
            await this._authService.check();

            resolve(this._authService.Me);
        });
    }
}
